import io from 'socket.io-client/dist/socket.io.dev';
import { alertMessage } from './acom_lang';

/**
 *
 * @param {Object} player
 * @param {Object} options
 */
export function slideReplay(player, options) {
  // console.log('slideReplay');
  // console.log(player, options);

  if (options.type === 'vod') {
    player.on('timeupdate', () => {
      options.pageTimestamp.forEach((item) => {
        if (item.seconds === Math.floor(player.currentTime())) {
          // console.log(item.page, item.seconds)
          $(options.carouselId).carousel(item.page - 1);
        }
      })
    });
  }
}

// 儲存最近一次有效的 Lag 數值，防止邊界抖動時突然掉入 0
let lastValidLag = 0;

/**
 * 取得當前播放器直播落後秒數 (Live Lag)
 * @param {string} playerId
 * @returns {number}
 */
export function getPlayerLag(playerId = 'acom-player') {
  try {
    const player = (typeof videojs !== 'undefined') ? videojs.getPlayer(playerId) : null;
    if (!player) {
      console.log('[SlideControl] getPlayerLag: player not found (' + playerId + ')');
      return lastValidLag;
    }
    if (typeof player.paused === 'function' && player.paused()) {
      console.log('[SlideControl] getPlayerLag: player is paused');
      return lastValidLag;
    }

    // 若新版 AcomPlayer 具備 getLiveLag 方法，直接調用
    if (typeof player.getLiveLag === 'function') {
      let lag = player.getLiveLag();
      if (lag > 0.3) {
        lastValidLag = lag;
      }
      console.log('[SlideControl] getPlayerLag via player.getLiveLag():', lag.toFixed ? lag.toFixed(2) : lag);
      return (lag > 0.3) ? lag : lastValidLag;
    }

    let end = 0;
    // 1. 優先使用 liveTracker
    if (player.liveTracker && typeof player.liveTracker.seekableEnd === 'function') {
      end = player.liveTracker.seekableEnd();
    }

    // 2. 次選原生 seekable 範圍
    if (!end || end <= 0) {
      let seekable = player.seekable && player.seekable();
      if (seekable && seekable.length > 0) {
        end = seekable.end(seekable.length - 1);
      }
    }

    // 3. 保底使用 bufferedEnd
    if (!end || end <= 0) {
      end = (typeof player.bufferedEnd === 'function') ? player.bufferedEnd() : 0;
    }

    let ct = (typeof player.currentTime === 'function') ? (player.currentTime() || 0) : 0;
    let lag = (end > ct) ? (end - ct) : 0;

    console.log('[SlideControl] getPlayerLag detail:', {
      edge: end.toFixed ? end.toFixed(2) : end,
      currentTime: ct.toFixed ? ct.toFixed(2) : ct,
      calculatedLag: lag.toFixed ? lag.toFixed(2) : lag,
      lastValidLag: lastValidLag.toFixed ? lastValidLag.toFixed(2) : lastValidLag
    });

    if (lag > 0.3 && lag < 60) {
      lastValidLag = lag;
      return lag;
    }

    // 若算出來小於 0.3s (邊界抖動或暫時性負值)，使用最近一次有效的 Lag
    return (lastValidLag > 0) ? lastValidLag : 0;
  } catch (e) {
    console.warn('[SlideControl] getPlayerLag error:', e);
    return lastValidLag;
  }
}

/**
 * @param {Object} options
 */
export function slideControl(options) {
  let ua = navigator.userAgent;
  let isAndroid = /Android/i.test(ua);

  options = Object.assign({
    url: '',
    eventName: 'slidechange',
    slideId: '',
    carouselId: '#carouse-indicators',
    playerId: 'acom-player',
    baseDelay: 5500,     // 基礎編碼傳輸延遲 5.5 秒
    defaultDelay: 6000,  // 若無法計算 lag 時的保底延遲 6 秒
  }, options);

  const socket = io(options.url);

  socket.emit('register', { slideId: options.slideId });

  socket.on(options.eventName, (data) => {
    console.log('[SlideControl] Received slidechange event:', data);

    let lag = getPlayerLag(options.playerId);
    let dynamicDelay;

    if (lag > 0) {
      dynamicDelay = Math.round(options.baseDelay + (lag * 1000));
      console.log(`[SlideControl] Dynamic delay applied: ${dynamicDelay}ms (baseDelay: ${options.baseDelay}ms + lag: ${(lag * 1000).toFixed(0)}ms) -> Target Page: ${data.page}`);
    } else {
      dynamicDelay = options.defaultDelay;
      console.log(`[SlideControl] Fallback default delay applied: ${dynamicDelay}ms -> Target Page: ${data.page}`);
    }

    setTimeout(() => {
      console.log(`[SlideControl] Flipping slide to page ${data.page} (index ${data.page - 1}) after ${dynamicDelay}ms`);
      $(options.carouselId).carousel(data.page - 1);
    }, dynamicDelay);
  });
}

export class Online {
  constructor (options) {
    this.options = options;
    this.socket = io(options.counterUrl, {
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
    });

    this.socket.on('connect', () => {
      console.log('[Socket] Connected!');
      this.syncStatus(); // 連線時同步一次狀態
    });

    this.socket.on('disconnect', (reason) => {
      console.log('[Socket] Disconnected:', reason);
    });

    // 監聽頁面顯示狀態，當使用者從背景回到前台時，強制同步狀態
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === 'visible') {
        console.log('[Visibility] Page became visible, syncing status...');
        this.syncStatus();
      }
    });

    this.socket.emit('join', {
      eventId: this.options.eventId,
      vodStatus: (this.options.player.type === 'vod' ? '1' : '0'),
    });

    this.socket.on('message', (data) => {
      this.onMessage(data);
    });

    if (Object.keys(player).length === 0) {
      axios.post(this.options.timestampUrl, { event_id: this.options.eventId })
        .then(response => {
          let serverTimestamp = response.data.now;
          let startOn = response.data.start_time;
          let endOn = response.data.end_time;

          this.startOnInterval = setInterval(() => {
            serverTimestamp++;

            if (serverTimestamp && startOn && serverTimestamp >= startOn) {
              this.initPlayer();

              clearInterval(this.startOnInterval);
            }
          }, 1000, serverTimestamp, startOn, endOn);
        });
    }
  }

  forceRemoveMask(nextPoster = null) {
    console.log('[UI] Aggressively removing mask elements...');
    
    let videoEl = document.getElementById('acom-player');
    
    // 1. 如果需要切換到過渡圖片
    if (nextPoster && videoEl) {
      videoEl.setAttribute('poster', nextPoster);
      videoEl.style.backgroundImage = `url('${nextPoster}')`;
      console.log(`[UI] Poster switched to: ${nextPoster}`);
      
      // 短暫延遲後再執行徹底清除，給瀏覽器一點緩衝時間
      setTimeout(() => this.cleanupMask(), 300);
      return;
    }

    // 2. 徹底清除邏輯
    this.cleanupMask();
  }

  cleanupMask() {
    let videoEl = document.getElementById('acom-player');
    if (videoEl) {
      videoEl.removeAttribute('poster');
      videoEl.style.backgroundImage = 'none';
      videoEl.classList.remove('has-poster');
    }
    
    if (typeof videojs !== 'undefined') {
        let player = videojs.getPlayer('acom-player');
        if (player) {
            player.poster(''); 
            let modal = player.getChild('ModalDialog');
            if (modal) {
                modal.close();
            }
        }
    }
    
    let modals = document.querySelectorAll('.vjs-my-fancy-modal, .vjs-modal-dialog');
    modals.forEach(modal => {
        modal.style.display = 'none';
    });
  }

  onMessage(data) {
    if (data.eventId && data.type && data.message) {
      switch (data.type) {
        case '0':
          this.resetPlayer();
          if (typeof question1 !== 'undefined') {
            question1.$data.props.manuallyOpen = false;
          }
          break;

        case '1':
        case '2':
        case '3':
          break;

        case '4': // on air
          player = this.initPlayer();
          // 直接執行徹底清除
          this.cleanupMask();
          if (typeof question1 === 'undefined') {
            question1.$data.props.manuallyOpen = true;
          }
          break;

        case '5': // 切換為vod
          if (Object.keys(player).length === 0) {
            player = this.initPlayer();
          }
          if (this.options.player.type !== 'vod') {
            let lang = this.options.lang;
            let confirm = {
              created () {
                this.$alert(alertMessage[lang].content, alertMessage[lang].title, {
                  confirmButtonText: alertMessage[lang].buttonText,
                  type: 'warning',
                  center: true,
                  callback (action) {
                    location.reload();
                  },
                });
              },
            };
            let Ctor = Vue.extend(confirm);
            new Ctor().$mount('#main');
          }
          break;

        case '9':
          break;
      }
    }
  }

  syncStatus() {
    axios.post(this.options.timestampUrl, { event_id: this.options.eventId })
      .then(response => {
        // 假設伺服器回傳狀態包含直播開始時間與目前是否在直播中
        // 這裡需要根據您的 API 實際回傳格式調整
        let isNowLive = (response.data.now >= response.data.start_time && response.data.now < response.data.end_time);
        
        if (isNowLive) {
          if (Object.keys(player).length === 0) {
             console.log('[Sync] Detecting live status, initializing player.');
             player = this.initPlayer();
          }
          // 不論是否剛初始化，都強制移除遮罩
          this.forceRemoveMask(null);
        }
      });
  }

  resetPlayer() {
    let acomPlayerParent = $('#acom-player').parent();

    //videojs(document.getElementById('acom-player')).dispose();
    // 2026-01-21 改用此方式確保獲取到實體再銷毀
    let oldPlayer = videojs.getPlayer('acom-player');
    if (oldPlayer) {
        oldPlayer.dispose();
    } else {
        // 如果 getPlayer 沒抓到，嘗試用舊方式強制銷毀
        let el = document.getElementById('acom-player');
        if (el) { videojs(el).dispose(); }
    }

    player = {};

    acomPlayerParent.prepend(`<video id="acom-player" class="video-js vjs-big-play-centered yt1920 yt1600 yt1366 yt1280 yt1200 yth w-100" crossorigin="anonymous"
      poster="/images/Artboard-1.jpg"></video>`);
  }

  initPlayer() {
    // 檢查播放器是否已經存在
    let existingPlayer = videojs.getPlayer(this.options.player.el);
    if (existingPlayer) {
      console.log('[UI] Player already initialized, skipping...');
      return existingPlayer;
    }

    return AcomPlayer(this.options.player.el, {
      type: this.options.player.type,
      genkeyUrl: this.options.player.genkeyUrl,
      videoSrc: this.options.player.videoSrc.live,
    });
  }
}
